import { JSX } from 'react';

// components
import { AtIcon } from '../at-icon';

// types
import { EIcons } from '../at-icon/icons';

// styles
import atPlayButton from './at-play-button.variants';
import classNames from 'classnames';
import { IAtPlayButtonProps } from './at-play-button.types';

/**
 * `AtPlayButton` is a stylized play button component used to trigger video playback.
 * It renders a scalable play icon with an optional animated circular ring behind it.
 * Used exclusively inside `OrFeaturedVideo`.
 *
 */

export const AtPlayButton = ({
  ariaLabel = 'play video',
  background = true,
  iconColor,
  onClick,
}: IAtPlayButtonProps): JSX.Element => {
  return (
    <button
      className={classNames([
        atPlayButton({ background }),
        'expandCoverage text-106 md:text-176',
      ])}
      aria-label={ariaLabel}
      type="button"
      onClick={onClick}
    >
      <div className="relative">
        <AtIcon
          icon={EIcons.PLAY_BUTTON}
          color={iconColor ?? 'var(--color-ui-knockout-primary)'}
          className="scale-[1.5] stroke-2 transition-all duration-300 ease-in-out group-focus:stroke-[4] md:group-hover:stroke-[4]"
        />

        <AtIcon
          icon={EIcons.CIRCLE}
          color={iconColor ?? 'var(--color-ui-knockout-primary)'}
          className="absolute inset-0 flex scale-[1.5] items-center justify-center stroke-[4] opacity-0 transition-opacity duration-200 md:group-focus:opacity-100"
        />
      </div>
    </button>
  );
};
